// Base URL for canonical/OG links (set VITE_APP_URL in your production environment).
// Example: VITE_APP_URL=https://activeshape.io
export const APP_URL = import.meta.env.VITE_APP_URL || '';

/**
 * Returns the absolute canonical URL for a given path, or null if APP_URL is not set.
 * @param {string} path - e.g. '/pricing'
 * @returns {string|null}
 */
export const canonical = (path) => (APP_URL ? `${APP_URL}${path}` : null);

/** Alias for canonical — use for og:url tags. */
export const ogUrl = (path) => canonical(path);

/**
 * Returns the absolute URL for an OG image, or null if APP_URL is not set.
 * Default image is /og-image.png — place a 1200×630 image at public/og-image.png.
 * @param {string} [imagePath='/og-image.png']
 * @returns {string|null}
 */
export const ogImage = (imagePath = '/og-image.png') => (APP_URL ? `${APP_URL}${imagePath}` : null);
